import React, { useState, useEffect, useRef } from 'react';
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Alert,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  Dimensions,
  ActivityIndicator,
  Modal
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Ionicons } from '@expo/vector-icons';
import { API_BASE_URL } from '../config/api';
import Constants from "expo-constants";
import TurnstileWidget from '../components/TurnstileWidget';
// Note: Registration endpoint not documented in current API specification
// import { registerUser } from '../services/authApi';
import { useFocusEffect } from '@react-navigation/native';
import '../styles/custom.css';

import DropDownPicker from 'react-native-dropdown-picker';
import DateTimePicker, { DateType, useDefaultStyles } from 'react-native-ui-datepicker';
import { MaskedTextInput } from "react-native-mask-text";

import { useFonts } from 'expo-font';
import * as DatePickerStyle from '../styles/datepicker.js';
import * as DropdownStyle from '../styles/dropdown.js';
import { getPendingQRs } from '../utils/pendingQR';
import { useCustomAlertModal } from '../components/CustomAlertModal';

const { width, height } = Dimensions.get('window');

export default function ProfileFormScreen({ navigation }) {
  const { 
    customAlertModal, 
    showCustomAlert, 
    hideCustomAlert, 
    handleCustomAlertConfirm
  } = useCustomAlertModal();

  const dmyPattern = /^\d{2}-\d{2}-\d{4}$/;
  const ymdPattern = /^\d{4}-\d{2}-\d{2}$/;

  const [userData, setUserData] = useState(null);

  const [formData, setFormData] = useState({
    fullName: '', 
    email: '', 
    phone: '', 
    gender: '', 
    birthDate: '', 
    province: '', 
    city: ''
  });
  
  const [isLoadSettings, setIsLoadSettings] = useState(false);
  const [minAge, setMinAge] = useState("21");

  const [genders, setGenders] = useState([
    {label: 'Laki-Laki', value: 'LAKI-LAKI'},
    {label: 'Perempuan', value: 'PEREMPUAN'},
  ]);
  const [isGenderOpen, setIsGenderOpen] = useState(false);

  const [isLoadProvinces, setIsLoadProvinces] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [isProvinceOpen, setIsProvinceOpen] = useState(false);

  const [isLoadCities, setIsLoadCities] = useState(false);
  const [cities, setCities] = useState([]);
  const [isCityOpen, setIsCityOpen] = useState(false);
  const [ocrCity, setOcrCity] = useState('');

  const [openDropdown, setOpenDropdown] = useState('');

  const [currentProvince, setCurrentProvince] = useState('');

  const [acceptTerms, setAcceptTerms] = useState(false);
  const [ageConfirmation, setAgeConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const datepickerDefaultStyles = useDefaultStyles();
  const [datepickerDate, setDatepickerDate] = useState(new Date());
  const [isDatepickerShown, setIsDatepickerShown] = useState(false);

  const [hasPendingQR, setHasPendingQR] = useState(false);
  const isDatepickerShownRef = useRef(isDatepickerShown);

  const [captchaToken, setCaptchaToken] = useState(null);

  const hideDatePicker = () => {
    setIsDatepickerShown(false);
  }

  const handleShowDatepicker = (date = null) => {
    if (date instanceof Date) {
      setDatepickerDate( date );
    } else if (typeof date === 'string') {
      let selectedDate = new Date();

      if( ymdPattern.test(date) ) selectedDate = new Date(date);
      else if(dmyPattern.test(date)) {
        const parts = date.split('-');
        selectedDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
      }

      // handle user giving invalid number string
      if(isNaN(selectedDate.getTime())) {
        if( date == formData.birthDate ) {
          handleInputChange('birthDate', '');
        }
        selectedDate = new Date();
      }

      setDatepickerDate(selectedDate);
    } else {
      setDatepickerDate( new Date() );
    }

    setIsDatepickerShown(true);
  }

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const validateForm = () => {
    const { fullName, email, phone, gender, birthDate, province, city } = formData;

    console.log('=== FORM VALIDATION START ===');

    if (! captchaToken) {
      showCustomAlert('Error', 'Pemeriksaan keamanan gagal! Silakan muat ulang dan coba beberapa saat lagi.');
      return false;
    }

    if (!fullName.trim()) {
      console.log('VALIDATION FAILED: No full name provided');
      showCustomAlert('Error', 'Nama lengkap harus diisi');
      return false;
    }

    if ( !birthDate.trim()) {
      console.log('VALIDATION FAILED: No birth date provided');
      showCustomAlert('Error', 'Tanggal lahir harus diisi');
      return false;
    }

    // Validate date format (DD-MM-YYYY)
    if (!dmyPattern.test(birthDate)) {
      console.log('VALIDATION FAILED: Invalid birth date format:', birthDate);
      showCustomAlert('Error', 'Format tanggal lahir harus DD-MM-YYYY (contoh: 15-01-1990)');
      return false;
    }

    // Validate that the date is a valid date
    const dateParts = birthDate.split('-');
    const day = parseInt(dateParts[0]);
    const month = parseInt(dateParts[1]);
    const year = parseInt(dateParts[2]);
    const date = new Date(year, month - 1, day);

    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      console.log('VALIDATION FAILED: Invalid birth date object:', birthDate);
      showCustomAlert('Error', 'Tanggal lahir tidak valid');
      return false;
    }

    // Validate reasonable birth date range
    const currentDate = new Date();
    const age = currentDate.getFullYear() - year;
    if (age < 0 || age > 120) {
      console.log('VALIDATION FAILED: Invalid age:', age);
      showCustomAlert('Error', 'Tanggal lahir tidak masuk akal');
      return false;
    }

    if (!gender.trim()) {
      console.log('VALIDATION FAILED: No gender provided');
      showCustomAlert('Error', 'Jenis kelamin harus dipilih');
      return false;
    }

    if (!['LAKI-LAKI', 'PEREMPUAN'].includes(gender.trim().toUpperCase())) {
      console.log('VALIDATION FAILED: Invalid gender provided');
      showCustomAlert('Error', 'Jenis kelamin tidak valid');
      return false;
    }

    // Validate that email is provided
    if (!email.trim()) {
      console.log('VALIDATION FAILED: No email provided');
      showCustomAlert('Error', 'Email harus diisi');
      return false;
    }

    // Validate email format if email is provided
    if (email.trim()) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        console.log('VALIDATION FAILED: Invalid email format:', email);
        showCustomAlert('Error', 'Format email tidak valid');
        return false;
      }
    }

    if (!province.trim()) {
      console.log('VALIDATION FAILED: No province provided');
      showCustomAlert('Error', 'Provinsi harus dipilih');
      return false;
    }

    if (!provinces.map(p => p.value).includes(province)) {
      console.log('VALIDATION FAILED: Invalid province provided');
      showCustomAlert('Error', 'Provinsi harus dipilih');
      return false;
    }

    if (!city.trim()) {
      console.log('VALIDATION FAILED: No city provided');
      showCustomAlert('Error', 'Kab/Kota harus dipilih');
      return false;
    }

    if (!cities.map(c => c.value).includes(city)) {
      console.log('VALIDATION FAILED: Invalid city provided');
      showCustomAlert('Error', 'Kab/Kota harus dipilih');
      return false;
    }

    // Validate that phone is provided
    if (!phone.trim()) {
      console.log('VALIDATION FAILED: No phone provided');
      showCustomAlert('Error', 'No. HP harus diisi');
      return false;
    }

    // Validate phone format if phone is provided
    if (phone.trim()) {
      // Basic phone validation - should contain only numbers and common phone characters
      const phoneRegex = /^[\d\s\-\+\(\)]+$/;
      if (!phoneRegex.test(phone)) {
        console.log('VALIDATION FAILED: Invalid phone format:', phone);
        showCustomAlert('Error', 'Format nomor HP tidak valid');
        return false;
      }
    }

    // Validate phone format to make sure it is valid Indonesian cellular number without heading of 08/628/+628
    if (phone.length < 8 || phone.length > 13) {
      console.log('VALIDATION FAILED: Invalid phone format:', phone);
      showCustomAlert('Error', 'Format nomor handphone tidak valid');
      return false;
    }

    // Validate phone format to make sure it is valid Indonesian cellular number without heading of 08/628/+628
    if (phone.startsWith('08') || phone.startsWith('628') || phone.startsWith('+628')) {
      console.log('VALIDATION FAILED: Invalid phone format:', phone);
      showCustomAlert('Error', 'Ketikkan nomor handphone setelah "08" saja');
      return false;
    }

    // if (!acceptTerms) {
    //   console.log('VALIDATION FAILED: Terms not accepted');
    //   showCustomAlert('Error', 'Anda harus menyetujui syarat dan ketentuan');
    //   return false;
    // }

    // if (!ageConfirmation) {
    //   console.log('VALIDATION FAILED: Age not confirmed');
    //   showCustomAlert('Error', `Anda harus mengkonfirmasi bahwa berusia ${minAge} tahun ke atas`);
    //   return false;
    // }

    console.log('=== FORM VALIDATION PASSED ===');
    return true;
  };

  const handleProfileCompletion = async () => {
    console.log('handleProfileCompletion called');
    // console.log('acceptTerms:', acceptTerms);
    // console.log('ageConfirmation:', ageConfirmation);
    console.log('isLoading:', isLoading);

    if (!validateForm()) {
      console.log('Form validation failed');
      return;
    }

    console.log('Form validation passed, starting profile completion...');
    setIsLoading(true);

    try {
      const completePhone = `08${formData.phone}` || "";
      
      // Prepare registration data according to updated API specification
      const profileData = {
        "user-id": userData.user_id,
        fullname: formData.fullName.toUpperCase(),
        "date-of-birth": formatDateForIdentity(formData.birthDate), // DD-MM-YYYY format
        gender : formData.gender,
        email: formData.email || "",
        telp: completePhone,
        province : formData.province.toUpperCase(),
        city : formData.city.toUpperCase(),
        "state-term": true,
        "state-21": true,
        'captcha-token': captchaToken,
      };

      console.log('Sending profile completion request...');

      const response = await fetch(`${API_BASE_URL}/api/profile-completion`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(profileData)
      });

      const result = await response.json();
      // console.log('Registration response:', result);

      if (result.status === 'success') {
        const pendingQRs = await getPendingQRs();
        if( pendingQRs.length > 0 ) {
          // if there is any pending QR, set flag to tell apps to automatiically klaim the voucher
          await AsyncStorage.setItem('autoClaimPendingQR', 'autoClaimPendingQR');
        }

        // remove locally saved creadential
        await AsyncStorage.removeItem('zclub-credential');
        // remove remindLater flag
        await AsyncStorage.removeItem('remindLater');

        if (result.data.userData) {
          await AsyncStorage.setItem('userData', JSON.stringify(result.data.userData));

          // Store session data if provided
          if (result.data.userData.remember_token) {
            await AsyncStorage.setItem('userToken', result.data.userData.remember_token);
          }
          // Store session data if provided
          if (result.data.userData.session_id) {
            await AsyncStorage.setItem('session_id', result.data.userData.session_id);
          }
        }

        // Navigate to homepage
        window.location.reload();
      } else {
        showCustomAlert('Error', result.message || 'Pendaftaran gagal. Silakan coba lagi.');
      }

    } catch (error) {
      console.error('Registration error:', error);
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        showCustomAlert('Error', 'Koneksi internet bermasalah. Silakan periksa koneksi Anda.');
      } else {
        showCustomAlert('Error', error.message || 'Pendaftaran gagal. Silakan coba lagi.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleRemindLater = async () => {
    await AsyncStorage.setItem('remindLater', 'remindLater');
    window.location.reload();
  }

  // Helper function to format date from DD-MM-YYYY or YYYY-MM-DD to DD-MM-YYYY
  const formatDateForIdentity = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('-');
    if (parts.length === 3) {
      // Check if it's already in DD-MM-YYYY format (day <= 31, month <= 12)
      if (parseInt(parts[0]) <= 31 && parseInt(parts[1]) <= 12) {
        return dateString; // Already in DD-MM-YYYY format
      }
      // Convert from YYYY-MM-DD to DD-MM-YYYY
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateString;
  };

  const loadSettings = async () => {
    setIsLoadSettings(true);

    try{
      const response = await fetch(`${API_BASE_URL}/api/v1/setting`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Api-Key": Constants.expoConfig?.extra?.API_KEY,
        },
        body: JSON.stringify({
          "keys": [
            'CONF_SYSTEM_MINIMUM_AGE'
          ],
        }),
      });

      const result = await response.json();
      setMinAge( result["CONF_SYSTEM_MINIMUM_AGE"] );

    } catch(e) {
      console.log(e);
      setMinAge( "21" )
    } finally {
      setIsLoadSettings(false);
    }
  }

  const loadProvinces = async () => {
    setIsLoadProvinces(true);

    try{
      const response = await fetch(`${API_BASE_URL}/api/v1/provinces`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Api-Key": Constants.expoConfig?.extra?.API_KEY,
        },
      });

      const result = await response.json();
      setProvinces( result.data.map(province => {
        return {
          label: province.nama_provinsi?.toUpperCase(),
          value: province.nama_provinsi?.toUpperCase(),
        };
      }) );

    } catch(e) {
      console.log(e);
      setProvinces([])
    } finally {
      setIsLoadProvinces(false);
    }
  }

  const loadCities = async () => {
    setIsLoadCities(true);

    const provinceData = new FormData();
    provinceData.append('provinsi', formData.province);

    try{
      const response = await fetch(`${API_BASE_URL}/api/v1/cities`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Api-Key": Constants.expoConfig?.extra?.API_KEY,
        },
        body: provinceData
      });

      const result = await response.json();
      setCities( result.data.map(city => {
        return {
          label: city.nama_kota?.toUpperCase(),
          value: city.nama_kota?.toUpperCase(),
        };
      }) );

    } catch(e) {
      console.log(e);
      setCities([])
    } finally {
      setIsLoadCities(false);
    }
  }

  const loadUserData = async () => {
    try {
      const userDataString = await AsyncStorage.getItem('userData');
      if( userDataString ) {
        setUserData( JSON.parse(userDataString) );
      }
    } catch(e) {
      console.log('Error fetching user data: ', e);
    }
  }

  useFocusEffect(
    React.useCallback(()=>{
      async function checkPendingQR() {
        const pendingQRs = await getPendingQRs();
        setHasPendingQR( pendingQRs.length > 0 );
      }

      loadSettings();
      loadProvinces();
      loadUserData();
      checkPendingQR();
    }, [navigation])
  );

  useEffect(() => {
    if( isProvinceOpen ) setOpenDropdown('province');
    if( isCityOpen ) setOpenDropdown('city');
  }, [isProvinceOpen, isCityOpen]);

  useEffect(() => {
    if(userData && userData.user_fullname) {
      handleInputChange('fullName', userData.user_fullname);
    }

    if(userData && userData.user_email) {
      handleInputChange('email', userData.user_email);
    }

    if(userData && userData.user_telp) {
      handleInputChange('phone', userData.user_telp.slice( -1 * (userData.user_telp.length - 2) ));
    }
  }, [userData]);

  useEffect(() => {
    isDatepickerShownRef.current = isDatepickerShown;
  }, [isDatepickerShown])

  // close datepicker when back button clicked
  useEffect(() => {
    const unsubscribe = navigation.addListener('beforeRemove', (e) => {
      // prevent user from going back since it can't trigger incomplete user block in home page
      e.preventDefault();
      console.log("Back requested!");

      if( isDatepickerShownRef.current ) {
        hideDatePicker();
      }
    });

    return unsubscribe;
  }, [navigation]);

  const [fontsLoaded] = useFonts({
    'Poppins': require('../../assets/fonts/Poppins-Regular.ttf'),
    'Poppins-Medium': require('../../assets/fonts/Poppins-Medium.ttf'),
    'Poppins-SemiBold': require('../../assets/fonts/Poppins-SemiBold.ttf'),
    'Poppins-Bold': require('../../assets/fonts/Poppins-Bold.ttf'),
  });

  return (
    <KeyboardAvoidingView
      style={styles.container}
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
    >
      <View style={styles.container}>
        <ScrollView
          contentContainerStyle={styles.scrollContent}
          showsVerticalScrollIndicator={false}
        >
          <View style={styles.header}>
            <TouchableOpacity
              style={styles.backButton}
              onPress={handleRemindLater}
            >
              <Ionicons name="arrow-back" size={24} color="#000000" />
            </TouchableOpacity>
          </View>

          {isLoadSettings || isLoadProvinces || !fontsLoaded ? (
            <ActivityIndicator size="large" color="#1E293B" />
          ) : (
            <View style={styles.content}>
              <View style={styles.titleSection}>
                <Text style={styles.title}>Profil Akun</Text>
                <Text style={styles.subtitle}>
                  Lengkapi sekali, lalu nikmati semua hadiah dari Zoolyfe!
                </Text>
              </View>

              <View style={styles.formSection}>
                <View style={[styles.formGroup, {marginBottom: 8}]}>
                  {/*<Text style={styles.label}>Tanggal Lahir *</Text>*/}
                  <View style={styles.inputContainer}>
                    <MaskedTextInput
                      mask="99-99-9999"
                      style={styles.input}
                      placeholder="Tanggal Lahir (DD-MM-YYYY)"
                      placeholderTextColor="#94A3B8"
                      value={formData.birthDate}
                      onChangeText={(text, rawText) => {
                        // const dobPattern = /^\d{2}-\d{2}-\d{4}$/;
                        // if( dobPattern.test(text) ) {
                        //   handleInputChange('birthDate', text);
                        // }
                        handleInputChange('birthDate', text);
                      }}
                      keyboardType="numeric"
                    />
                    <TouchableOpacity
                      style={styles.inputIcon}
                      onPress={() => handleShowDatepicker(formData.birthDate)}
                    >
                      <Ionicons
                        name="calendar-outline"
                        size={20}
                        color="#64748B"
                      />
                    </TouchableOpacity>
                  </View>
                </View>

                <View
                  style={{
                    ...styles.formGroup,
                    zIndex: 5002,
                    marginBottom: 8,
                  }}
                >
                  {/*<Text style={styles.label}>Jenis Kelamin *</Text>*/}
                  <View style={styles.inputContainer}>
                    <DropDownPicker
                      style={DropdownStyle.customStyles.dropdown}
                      textStyle={DropdownStyle.customStyles.dropdownText}
                      disabledStyle={DropdownStyle.customStyles.dropdownDisabled}
                      placeholderStyle={DropdownStyle.customStyles.dropdownPlaceholder}
                      dropDownContainerStyle={DropdownStyle.customStyles.dropdownContainer}
                      listItemLabelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                      labelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                      placeholder="Jenis Kelamin"
                      searchable={false}
                      open={isGenderOpen}
                      value={formData.gender}
                      items={genders}
                      setOpen={setIsGenderOpen}
                      setItems={setGenders}
                      onSelectItem={(item) => {
                        handleInputChange('gender', item.value);
                      }}
                    />
                  </View>
                </View>

                <View
                  style={{
                    ...styles.formGroup,
                    marginBottom: 8,
                    zIndex: openDropdown == 'province' ? 5001 : 5000,
                  }}
                >
                  {/*<Text style={styles.label}>Alamat *</Text>*/}
                  <View style={styles.inputContainer}>
                    <DropDownPicker
                      style={DropdownStyle.customStyles.dropdown}
                      textStyle={DropdownStyle.customStyles.dropdownText}
                      disabledStyle={DropdownStyle.customStyles.dropdownDisabled}
                      placeholderStyle={DropdownStyle.customStyles.dropdownPlaceholder}
                      dropDownContainerStyle={DropdownStyle.customStyles.dropdownContainer}
                      listItemLabelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                      labelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                      searchContainerStyle={DropdownStyle.customStyles.dropdownSearch}
                      searchTextInputStyle={DropdownStyle.customStyles.dropdownSearchText}
                      searchTextInputProps={{
                        autoFocus: true,
                      }}
                      placeholder="Provinsi"
                      searchable={true}
                      open={isProvinceOpen}
                      value={formData.province}
                      items={provinces}
                      setOpen={setIsProvinceOpen}
                      setItems={setProvinces}
                      onSelectItem={(item) => {
                        handleInputChange('province', item.value);
                      }}
                      onChangeValue={async ()=>{
                        await loadCities();
                        handleInputChange('city', ocrCity);
                        if( !formData.city ) {
                          setOcrCity('');
                        }
                      }}
                    />
                  </View>
                </View>

                <View
                  style={{
                    ...styles.formGroup,
                    marginBottom: 8,
                    zIndex: openDropdown == 'city' ? 5001 : 5000,
                  }}
                >
                  <View style={styles.inputContainer}>
                    <DropDownPicker
                      style={DropdownStyle.customStyles.dropdown}
                      textStyle={DropdownStyle.customStyles.dropdownText}
                      // disabledStyle={DropdownStyle.customStyles.dropdownDisabled}
                      placeholderStyle={DropdownStyle.customStyles.dropdownPlaceholder}
                      dropDownContainerStyle={DropdownStyle.customStyles.dropdownContainer}
                      listItemLabelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                      labelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                      searchContainerStyle={DropdownStyle.customStyles.dropdownSearch}
                      searchTextInputStyle={DropdownStyle.customStyles.dropdownSearchText}
                      searchTextInputProps={{
                        autoFocus: true,
                      }}
                      placeholder="Kab/Kota"
                      searchable={true}
                      open={isCityOpen}
                      value={formData.city}
                      items={cities}
                      setOpen={setIsCityOpen}
                      setItems={setCities}
                      onSelectItem={(item) => {
                        handleInputChange('city', item.value);
                      }}
                      disabled={isLoadCities || !formData.province}
                    />
                  </View>
                </View>

                <View style={styles.formSectionDivider} />

                <View style={[styles.formGroup, {marginBottom: 8}]}>
                  {/*<Text style={styles.label}>{`Nama Lengkap *`}</Text>*/}
                  <View style={styles.inputContainer}>
                    <TextInput
                      style={styles.input}
                      placeholder={`Nama Lengkap`}
                      placeholderTextColor="#94A3B8"
                      value={formData.fullName}
                      onChangeText={(value) => handleInputChange('fullName', value)}
                      autoCapitalize="words"
                      autoCorrect={false}
                    />
                  </View>
                </View>

                <View style={[styles.formGroup, {marginBottom: 8}]}>
                  {/*<Text style={styles.label}>Email *</Text>*/}
                  <View style={!!userData && !userData.user_email ? styles.inputContainer : styles.inputContainerDisabled}>
                    <TextInput
                      style={styles.input}
                      placeholder="Email (contoh@email.com)"
                      placeholderTextColor="#94A3B8"
                      value={formData.email}
                      onChangeText={(value) => handleInputChange('email', value)}
                      keyboardType="email-address"
                      autoCapitalize="none"
                      autoCorrect={false}
                      editable={!!userData && !userData.user_email}
                    />
                  </View>
                </View>

                <View style={styles.formGroup}>
                  <View style={!!userData && !userData.user_telp ? styles.inputContainer : styles.inputContainerDisabled}>
                    <Text style={styles.inputPrefix}>08-</Text>
                    <MaskedTextInput
                      mask="999-9999999999"
                      style={styles.input}
                      placeholder="xxx-xxxxxxx"
                      placeholderTextColor="#94A3B8"
                      value={formData.phone}
                      onChangeText={(text, rawText) => {
                        handleInputChange('phone', rawText);
                      }}
                      keyboardType="phone-pad"
                      autoCorrect={false}
                      editable={!!userData && !userData.user_telp}
                    />
                  </View>
                </View>

                {/*<View style={styles.checkboxContainer}>
                  <TouchableOpacity
                    style={[styles.checkbox, ageConfirmation && styles.checkboxChecked]}
                    onPress={() => setAgeConfirmation(!ageConfirmation)}
                  >
                    {ageConfirmation && (
                      <Ionicons name="checkmark" size={16} color="#FFFFFF" />
                    )}
                  </TouchableOpacity>
                  <Text style={styles.checkboxText}>
                    {`Saya menyatakan sudah berusia ${minAge} tahun keatas.`}
                  </Text>
                </View>*/}

                {/*<View style={styles.checkboxContainer}>
                  <TouchableOpacity
                    style={[styles.checkbox, acceptTerms && styles.checkboxChecked]}
                    onPress={() => setAcceptTerms(!acceptTerms)}
                  >
                    {acceptTerms && (
                      <Ionicons name="checkmark" size={16} color="#FFFFFF" />
                    )}
                  </TouchableOpacity>
                  <Text style={styles.checkboxText}>
                    Saya menyetujui {' '}
                    <Text style={styles.linkText}>Syarat & Ketentuan</Text>
                    {' '} serta  {' '}
                    <Text style={styles.linkText}>Kebijakan Privasi</Text>
                    {' '} Zoolyfe.
                  </Text>
                </View>*/}

                <View style={{flexDirection: 'row', gap: 12}}>
                  <TouchableOpacity
                    style={[styles.registerButton, {flex: 1}, (isLoading) && styles.disabledButton]}
                    onPress={handleProfileCompletion}
                    disabled={isLoading}
                  >
                    <Text style={styles.registerButtonText}>
                      {isLoading ? 'Memproses...' : hasPendingQR ? 'Klaim Sekarang' : 'Simpan'}
                    </Text>
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={[styles.registerButton, {flex: 1, backgroundColor: '#F3F4F6'}]}
                    onPress={handleRemindLater}
                  >
                    <Text style={[styles.registerButtonText, {color: '#374151'}]}>Ingatkan Nanti</Text>
                  </TouchableOpacity>
                </View>
              </View>

              {/* Turnstile renders only on web */}
              {Platform.OS === 'web' && (
                <TurnstileWidget
                  siteKey={Constants.expoConfig?.extra?.TURNSTILE_SITE_KEY}
                  onVerify={(token) => setCaptchaToken(token)}
                />
              )}
            </View>
          )}
        </ScrollView>
      </View>

      {/* Custom Alert Modal */}
      {customAlertModal}

      {/* Date Picker Modal */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={isDatepickerShown}
        onRequestClose={hideDatePicker}
      >
        <TouchableOpacity 
          style={styles.datepickerOverlay}
          onPress={hideDatePicker}
          activeOpacity={1}
        >
          <TouchableOpacity 
            style={styles.datepickerContainer} 
            onPress={(e) => e.stopPropagation()}
            activeOpacity={1}
          >
            <View style={styles.datepickerBody}>
              <DateTimePicker
                locale="id"
                mode="single"
                maxDate={new Date()}
                date={datepickerDate}
                onChange={({ date }) => {
                  setDatepickerDate(date);
                  
                  const dateString = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
                  handleInputChange('birthDate', dateString);
                  hideDatePicker();
                }}
                styles={{
                  ...datepickerDefaultStyles,
                  ...DatePickerStyle.customStyles
                }}
              />
            </View>
            <View style={styles.datepickerFooter}>
              <TouchableOpacity
                onPress={hideDatePicker}
              >
                <Text style={styles.datepickerCancelButton}>Batal</Text>
              </TouchableOpacity>
            </View>
          </TouchableOpacity>
        </TouchableOpacity>
      </Modal>
    </KeyboardAvoidingView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  scrollContent: {
    flexGrow: 1,
    padding: 16,
    paddingTop: 32,
  },
  header: {
    marginBottom: 32,
  },
  backButton: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    flex: 1,
  },
  titleSection: {
    marginBottom: 32,
  },
  title: {
    fontSize: 30,
    lineHeight: 36,
    fontFamily: 'Poppins-Semibold',
    fontWeight: 600,
    color: '#00000',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 14,
    lineHeight: 24,
    fontFamily: 'Poppins',
    color: '#64748B',
  },
  formSection: {
    flex: 1,
  },
  formSectionDivider: {
    height: 1,
    backgroundColor: '#DDDDDD',
    marginTop: 12,
    marginBottom: 20,
  },
  formGroup: {
    marginBottom: 20,
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
    color: '#374151',
    marginBottom: 8,
    fontFamily: 'Poppins-Medium',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#AAAAAA',
    paddingHorizontal: 16,
    height: 48,
  },
  inputContainerDisabled: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#E2E8F0',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#AAAAAA',
    paddingHorizontal: 16,
    height: 48,
  },
  input: {
    flex: 1,
    fontSize: 16,
    color: '#1E293B',
    fontFamily: 'Poppins',
  },
  inputDisabled: {
    flex: 1,
    fontSize: 16,
    color: '#1E293B',
    backgroundColor: '#E2E8F0',
    fontFamily: 'Poppins',
  },
  inputPrefix: {
    fontSize: 16,
    color: '#1E293B',
    fontFamily: 'Poppins',
    // marginRight: 8,
  },
  eyeIcon: {
    padding: 4,
  },
  inputIcon: {
    marginLeft: 8,
  },
  uploadContainer: {
    borderWidth: 1,
    borderColor: '#94A3B8',
    borderStyle: 'dashed',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    height: 136,
    justifyContent: 'center',
    alignItems: 'center',
  },
  uploadContent: {
    alignItems: 'center',
    width: 208,
  },
  uploadText: {
    fontSize: 14,
    color: '#1E293B',
    marginTop: 8,
    fontWeight: '600',
    fontFamily: 'Poppins',
    textAlign: 'center',
  },
  uploadSubtext: {
    fontSize: 12,
    color: '#94A3B8',
    marginTop: 4,
    fontFamily: 'Poppins',
    textAlign: 'center',
    lineHeight: 16,
  },
  uploadContainerProcessing: {
    borderColor: '#3B82F6',
    backgroundColor: '#F0F9FF',
  },
  ocrHintText: {
    fontSize: 11,
    color: '#3B82F6',
    marginTop: 6,
    fontFamily: 'Poppins',
    textAlign: 'center',
    fontWeight: '500',
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  checkbox: {
    width: 20,
    height: 20,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
    marginTop: 2,
  },
  checkboxChecked: {
    backgroundColor: '#000000',
    borderColor: '#000000',
  },
  checkboxText: {
    flex: 1,
    fontSize: 12,
    color: '#374151',
    lineHeight: 16,
    fontFamily: 'Poppins',
  },
  linkText: {
    color: '#3B82F6',
    fontWeight: '500',
  },
  registerButton: {
    backgroundColor: '#1E293B',
    borderRadius: 6,
    padding: 12,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 24,
    marginTop: 4,
  },
  disabledButton: {
    opacity: 0.5,
  },
  registerButtonText: {
    fontFamily: 'Poppins-Medium',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: 20,
    color: '#FFFFFF',
  },
  loginContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loginText: {
    fontSize: 14,
    color: '#64748B',
  },
  loginLink: {
    fontSize: 14,
    color: '#3B82F6',
    fontWeight: '600',
  },
  note: {
    fontSize: 12,
    color: '#94A3B8',
    marginTop: 6
  },

  

  // Custom Modal Styles
  datepickerOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  datepickerContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    width: '100%',
    maxWidth: 400,
    overflow: 'hidden',
    elevation: 5,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    cursor: 'default',
  },
  datepickerBody: {
    padding: 20,
  },
  datepickerFooter: {
    padding: 20,
    paddingTop: 0,
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
  },
  datepickerCancelButton: {
    fontFamily: 'Poppins',
    fontSize: 16,
    color: '#000000'
  },
  datepickerCustomStyles: {
    day_label: {
      color: '#000000'
    },
    month: {
      borderWidth: 0,
    },
    month_label: {
      color: '#000000',
      fontWeight: 500,
    },
    selected_month: {
      backgroundColor: '#94A3B8'
    },
    selected_month_label: {
      color: '#FFFFFF'
    },
    year: {
      borderWidth: 0,
    },
    year_label: {
      color: '#000000',
      fontWeight: 500,
    },
    selected_year: {
      backgroundColor: '#94A3B8'
    },
    selected_year_label: {
      color: '#FFFFFF'
    },
    month_selector_label: {
      color: '#000000',
      fontWeight: 700,
    },
    year_selector_label: {
      color: '#000000',
      fontWeight: 700,
    },
    weekday_label: {
      color: '#000000',
      fontWeight: 700,
    },
    today: {
      backgroundColor: '#CCCCCC'
    },
    selected: {
      backgroundColor: '#3B82F6'
    },
    selected_label: {
      color: '#FFFFFF'
    },
    button_next_image: {
      opacity: 1,
      filter: 'none',
    },
    button_prev_image: {
      opacity: 1,
      filter: 'none',
    },
    button_next: {
      opacity: 1,
      filter: 'none',
    },
    button_prev: {
      opacity: 1,
      filter: 'none',
    }
  }
});
